import * as React from "react";

function FeatureList() {
  const features = [
    {
      title: "Reclaim Your Time:",
      description: "so you can focus on strategy and service."
    },
    {
      title: "Frictionless Operations:",
      description: "every transaction is tracked and secured."
    },
    {
      title: "Seamless Scalability:",
      description: "start with a single module, expand anytime."
    }
  ];

  return (
    <div className="flex flex-col gap-4">
      {features.map((feature, index) => (
        <div key={index} className="flex gap-3 items-start">
          <div className="flex justify-center items-center mt-0.5 w-6 h-6 rounded-full bg-zinc-900 flex-shrink-0">
            <i className="ti ti-check text-sm text-white" />
          </div>
          <div className="text-base leading-normal text-zinc-800 max-sm:text-base">
            <span className="font-semibold">{feature.title}</span>
            {feature.description}
          </div>
        </div>
      ))}
    </div>
  );
}

export default FeatureList;
